module.exports = __webpack_public_path__ + "img/play.9a979f99.png";